import baseRequest from "../_core/baseRequest";

export default {
    createAndActivateCourierWallet: params =>
        baseRequest.post(
            `/wallet/courier/${params?.courierId}/create-and-activate-courier-wallet`,
            params
        ),

    updateCourierWalletBlockedBalance: params =>
        baseRequest.post(`/wallet/courier/${params?.courierId}/update-blocked-balance`, {
            blockedBalance: params?.blockedBalance
        }),

    updateCourierWalletCashOnDeliveryLimitOffset: params =>
        baseRequest.post(`/wallet/courier/${params?.courierId}/update-cod-limit-offset`, {
            cashOnDeliveryLimitOffset: params?.cashOnDeliveryLimitOffset
        }),

    getCourierWalletWithDailyTransactionsSummary: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}?${
                params?.startDate ? `startDate=${params.startDate}` : ""
            }&${params?.endDate ? `endDate=${params.endDate}` : ""}${
                params?.skip !== undefined ? `&skip=${params.skip}` : ""
            }${params?.limit !== undefined ? `&limit=${params.limit}` : ""}`
        ),

    getDailyTransactionsSummary: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/daily-summary?${
                params?.dailyTransactionId ? `dailyTransactionId=${params.dailyTransactionId}` : ""
            }`,
            params
        ),

    getDailyTransactions: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/daily-transactions?${
                params?.dailyTransactionId ? `dailyTransactionId=${params.dailyTransactionId}` : ""
            }`,
            params
        ),

    getCourierCreditLogSummary: params =>
        baseRequest.post(`/wallet/courier/${params?.courierId}/credit-log-summary`, params),

    getCourierPaymentInvoices: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/payment-invoices?${
                params?.startDate ? `startDate=${params.startDate}` : ""
            }&${params?.endDate ? `endDate=${params.endDate}` : ""}${
                params?.status ? `&status=${params.status}` : ""
            }`
        ),

    getCourierWalletPayments: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/payments?${
                params?.startDate ? `&startDate=${params.startDate}` : ""
            }${params?.endDate ? `&endDate=${params.endDate}` : ""}${
                params?.status ? `&status=${params.status}` : ""
            }`
        ),

    listWalletCouriers: params => baseRequest.post(`/wallet/courier`, params),

    blockWithdrawAction: params => baseRequest.post(`/wallet/block-withdraw-action`, params),

    unblockWithdrawAction: params => baseRequest.post(`/wallet/unblock-withdraw-action`, params),

    getWalletInvoiceVendors: params => baseRequest.get(`/wallet/invoice-vendors`, params),
    uploadWalletCourierFinancialFile: params =>
        baseRequest.post("/wallet/courier-financial-uploads", params, true),
    listWalletCourierFinancials: params =>
        baseRequest.get(
            `/wallet/courier-financial-uploads?${
                params?.courierId ? `courierId=${params.courierId}` : ""
            }${params?.type ? `&type=${params.type}` : ""}`
        ),
    listUploadTypes: () => baseRequest.get(`/wallet/upload-transaction-types`),
    getCourierFinancialUploadsTemplate: () =>
        baseRequest.get(`/wallet/courier-financial-uploads-template`),
    createFinancialUploadExcelToSpecificCourier: params =>
        baseRequest.post(`/wallet/create-financial-upload-excel-to-specific-courier`, params, true),
    generateWithdrawSummary: params =>
        baseRequest.post(`/wallet/generate-withdraw-summary`, params),
    approveWithdraw: params => baseRequest.post(`/wallet/approve-withdraw`, params),
    bulkWithdrawTerminated: params => baseRequest.post(`/wallet/bulk-withdraw-terminated`, params),
    getTerminatedCouriersCountForWithdraw: () =>
        baseRequest.get(`/wallet/terminated-couriers-count-for-withdraw`),
    deactivateCourierWallet: (courierId, data) => {
        return baseRequest.post(`/wallet/courier/${courierId}/deactivate-wallet`, data);
    },
    activateCourierWallet: (courierId, data) => {
        return baseRequest.post(`/wallet/courier/${courierId}/activate-wallet`, data);
    },
    getWalletActivationPreview: (courierId, {customStartDate, customStartTime} = {}) => {
        const queryParams = new URLSearchParams();
        if (customStartDate) queryParams.append("customStartDate", customStartDate);
        if (customStartTime) queryParams.append("customStartTime", customStartTime);
        const qs = queryParams.toString();
        return baseRequest.get(
            `/wallet/courier/${courierId}/activation-preview${qs ? `?${qs}` : ""}`
        );
    },
    checkInvoiceStatus: courierId => {
        return baseRequest.post("/wallet/checkInvoiceStatus", {courierId});
    },
    checkInvoiceIdStatus: invoiceId => {
        return baseRequest.post("/wallet/checkInvoiceIdStatus", {invoiceId});
    },
    checkPaymentIdStatus: invoiceId => {
        return baseRequest.post("/wallet/checkPaymentIdStatus", {invoiceId});
    },
    exportCourierWalletTransactions: params => {
        return baseRequest.post(
            `/wallet/courier/${params?.courierId}/export-transactions`,
            {
                startDate: params?.startDate,
                endDate: params?.endDate
            },
            true
        );
    },
    sendWithdrawSms: params => {
        return baseRequest.post(`/wallet/send-withdraw-sms`, params);
    },
    sendReturnSms: params => {
        return baseRequest.post(`/wallet/send-invoice-sms`, params);
    }
};
